export { default as component } from "../../../../src/routes/[prefix]/(feature)/manual/+page.svelte";